import { useTranslations } from 'next-intl';
import { CardTitle } from '@/app/components/ui/card';
import { ENTERPRISE_COPY, isEnterpriseDistribution } from '@/app/constants';

export const LoginCardTitle = () => {
  const t = useTranslations();
  const title = isEnterpriseDistribution ? ENTERPRISE_COPY.login.cardTitle : t('login.title');
  return (
    // 上方已有 Vidu 字标，标题降为副标题字号，原 slogan 去掉。
    <CardTitle className="text-center">
      <div className="font-normal text-base text-system-white64 leading-6 lg:text-sm">{title}</div>
    </CardTitle>
  );
};
